import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import MerchantCategoryFormHandler from '../../containers/formHandlers/center/merchant/merchantCategory/MerchantCategoryFormHandler';
import MerchantObjectionReasonFormHandler from '../../containers/formHandlers/center/merchant/merchantObjectionReason/MerchantObjectionReasonFormHandler';

const Merchant: React.FC = () => {
  return (
    <CC.Flex justifyContent={'space-between'} gap={'5'} direction={{base: 'column', md: 'row'}}>
      <CC.Box boxShadow={'md'} p={'1.5em'} w={'100%'}>
        <CC.Heading size="md" mb={4}>Catégorie marchand</CC.Heading>
        <MerchantCategoryFormHandler />
      </CC.Box>
      <CC.Box boxShadow={'md'} p={'1.5em'} w={'100%'}>
        <CC.Heading size="md" mb={4}>Motif opposition commerçant</CC.Heading>
        <MerchantObjectionReasonFormHandler />
      </CC.Box>
    </CC.Flex>
    )
}

export default Merchant;